


















import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/vuex/index';
@Component({
    components: {
      
    },
})
export default class home extends Vue {
   

    public $refs: {
        barcodeCanvas:HTMLFormElement
    };
    created() {
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/home/Home.vue